// extracted by mini-css-extract-plugin
export default {"imageWrapper":"Gp-z","videoWrapper":"Hp-z","twoColumnImage":"Ip-z","imageCarouselBtn":"Jp-z","carouselNextBtn":"Kp-z","carouselPrevBtn":"Lp-z"};